/* eslint-disable */
import React, { useEffect, useState } from 'react';
import Downshift from 'downshift';
import injectSheet from 'react-jss';
import { TweenMax } from 'gsap';
import classNames from 'classnames';
import MobileDetect from '../../utils/mobileDetect';

const styleSheet = (theme: any) => ({
  '@global': {
    '*::-webkit-scrollbar': {
      width: '8px',
    },
    '*::-webkit-scrollbar-track': {
      borderRadius: '3px',
      backgroundColor: '#f5f7ff',
    },
    '*::-webkit-scrollbar-thumb': {
      borderRadius: '3px',
      backgroundColor: '#b7c1e1',
    },
  },
  select: {
    '&::placeholder': {
      textOverflow: 'ellipsis !important',
      color: '#b7c1e1',
    },
    '&:-ms-input-placeholder': {
      textOverflow: 'ellipsis !important',
      color: '#b7c1e1',
    },
    '&:focus': {
      border: 'solid 2px #085fe5',
    },
    position: 'relative',
    cursor: 'pointer',
    fontFamily: 'CircularStd, sans-serif',
    fontWeight: '500',
    zIndex: 2,
    outline: 'none',
    width: '100%',
    height: '72px',
    borderRadius: '6px',
    border: 'solid 2px #b7c1e1',
    fontSize: '24px',
    color: '#4f5b84',
    textAlign: 'left',
    padding: '0 32px',
    backgroundColor: '#fff',
    appearance: 'none',
    '& .icon': {
      transformOrigin: '50% 50%',
      width: '30px',
      position: 'absolute',
      right: '25px',
      top: '50%',
      transform: 'translateY(-50%)',
      '@media (max-width: 900px)': {
        width: '25px',
      },
    },
  },
  mobileIcon: {
    position: 'absolute',
    right: '40px',
    zIndex: 1,
    bottom: '20px',
    width: '30px',
    '@media (max-width: 900px)': {
      right: '26px',
      width: '20px',
    },
    '@media (max-width: 360px)': {},
  },
  label: {
    ...theme.label,
    display: 'block',
    textAlign: 'left',
    paddingLeft: '9px',
    marginBottom: '14px',
    color: '#223762',
    fontWeight: '800',
  },
  error: theme.button.error,
  wrapper: {
    flex: 1,
    position: 'relative',
  },
  optionsHolder: {
    position: 'absolute',
    width: '100%',
    zIndex: 1,
  },
  dropDown: {
    border: 'solid 2px #b7c1e1',
    borderTop: 'none',
    backgroundColor: '#fff',
    marginTop: '-4px',
    borderBottomRightRadius: '6px',
    borderBottomLeftRadius: '6px',
    maxHeight: '208px',
    overflowY: 'scroll',
    position: 'relative',
    zIndex: 2,
  },
  hideOnMobile: {},
  dropDownItem: {
    cursor: 'pointer',
    padding: '16px 32px',
    fontSize: '24px',
    textAlign: 'left',
    fontWeight: '500',
    fontFamily: 'CircularStd, sans-serif',
    color: '#4f5b84',
    borderRadius: '6px',
    position: 'relative',
  },
  input: {
    '&::placeholder': {
      textOverflow: 'ellipsis !important',
      color: '#b7c1e1',
    },
    '&:-ms-input-placeholder': {
      textOverflow: 'ellipsis !important',
      color: '#b7c1e1',
    },
    outline: 0,
    width: '100%',
    height: '72px',
    objectFit: 'contain',
    borderRadius: '6px',
    border: 'solid 2px #b7c1e1',
    boxSizing: 'border-box',
    padding: '24px 27px',
    fontSize: '24px',
    color: '#4f5b84',
  },
  '@media (max-width: 900px)': {
    hideOnMobile: {
      display: 'none',
    },
    input: {
      height: '64px',
      fontSize: '20px',
    },
    select: {
      height: '64px',
      fontSize: '20px',
    },
    label: {
      fontSize: '10px',
    },
    dropDownItem: {
      fontSize: '20px',
    },
  },
});

interface Props {
  value: any;
  error?: boolean;
  classes?: any;
  items?: any;
  placeholder?: string;
  label?: string;
  name: string;
  defaultValue?: any;
  ariaLabel?: string;
  onChange?: (e: object) => void;
}

const SelectBox: React.FC<Props> = props => {
  const mapValueToSelectedItem =
    props.items.find((item: { value: string }) => item.value === props.value) ||
    null;

  const [selectedOption, setOption] = useState(
    mapValueToSelectedItem?.label || props.defaultValue?.label
  );

  useEffect(() => {
    if (selectedOption) {
      let saveItem = mapValueToSelectedItem || props.defaultValue;
      onChange({ label: saveItem.label, value: `${saveItem.value}` });
    }
  }, []);

  const isMobile = MobileDetect.phone() ? true : false;

  const onChange = (selected: { label: string; value: string }) => {
    setOption(selected.label);
    let response = { target: { value: selected.value, fieldId: props.name } };
    props.onChange ? props.onChange(response) : null;
  };

  const onMobileChange = (event: React.ChangeEvent<any>) => {
    setOption(event.target.value);
    let response = {
      value: event.target.value,
      name: event.target.name,
      fieldId: event.target.name,
    };
    props.onChange ? props.onChange({ target: response }) : null;
  };

  if (!isMobile) {
    // Desktop select style //
    return (
      <Downshift
        onChange={selected => {
          onChange(selected);
        }}
        initialSelectedItem={selectedOption}
      >
        {({
          isOpen,
          getToggleButtonProps,
          getItemProps,
          highlightedIndex,
          selectedItem: dsSelectedItem,
          getLabelProps,
        }) => (
          <div className={props.classes.wrapper}>
            <label
              className={classNames(props.classes.label, {
                [props.classes.hideOnMobile]: props.label.length == 1,
              })}
            >
              {props.label}
            </label>
            <label {...getLabelProps()} style={{ display: 'none' }}>
              {props.ariaLabel}
            </label>
            <button
              aria-label={props.ariaLabel}
              name={props.name}
              data-type={'list'}
              style={{ color: selectedOption ? '#4f5b84' : '#b7c1e1' }}
              className={classNames(props.classes.select, {
                [props.classes.error]: props.error,
              })}
              {...getToggleButtonProps()}
            >
              {selectedOption ? selectedOption : 'Select'}
              <img
                style={{
                  transform: isOpen
                    ? 'translateY(-50%) rotate(180deg)'
                    : 'translateY(-50%)',
                }}
                className="icon"
                src="images/UI/downarrow.svg"
              />
            </button>
            <div className={props.classes.optionsHolder}>
              {isOpen ? (
                <div
                  aria-label={props.ariaLabel}
                  className={classNames(props.classes.dropDown, {
                    [props.classes.error]: props.error,
                  })}
                >
                  {props.items.map((item: { label: String }, index: number) => (
                    <div
                      role="select"
                      aria-selected={selectedOption === item.label}
                      aria-label={item.label}
                      className={props.classes.dropDownItem}
                      {...getItemProps({ key: index, index, item })}
                      style={{
                        backgroundColor:
                          highlightedIndex === index
                            ? '#f5f7ff'
                            : 'transparent',
                        fontWeight:
                          selectedOption === item.label ? 'bold' : 'normal',
                        color:
                          selectedOption === item.label ? '#223762' : '#505C81',
                      }}
                    >
                      {selectedOption === item.label && (
                        <img
                          style={{
                            position: 'absolute',
                            left: '9px',
                            top: '26px',
                          }}
                          src="images/UI/selected_item.svg"
                        />
                      )}
                      {item.label}
                    </div>
                  ))}
                </div>
              ) : null}
            </div>
          </div>
        )}
      </Downshift>
    );
  } else {
    // Mobile select style //
    return (
      <React.Fragment>
        <label
          className={classNames(props.classes.label, {
            [props.classes.hideOnMobile]: props.label.length == 1,
          })}
        >
          {props.label}
        </label>
        <img
          className={props.classes.mobileIcon}
          src="images/UI/downarrow.svg"
        />
        <select
          name={props.name}
          className={classNames(props.classes.select, {
            [props.classes.error]: props.error,
          })}
          style={{ color: props.value ? '#4f5b84' : '#b7c1e1' }}
          onChange={selected => onMobileChange(selected)}
          value={selectedOption ? selectedOption : 'Select'}
        >
          <option value="Select" disabled>
            Select
          </option>
          {props.items.map((item: { label: String }, index: number) => (
            //@ts-ignore
            <option key={index} value={item.value}>
              {item.label}
            </option>
          ))}
        </select>
      </React.Fragment>
    );
  }
};

export default injectSheet(styleSheet)(SelectBox);
